// What the form still needs before it can be sent.
//
// The legacy drawer kept its save button disabled until every field it showed
// was filled in — the one exception being the repeat, which has "never" as an
// answer. The rule here is the same, read from the descriptor instead of from
// a branch per announcement type: whatever the server marked as required and
// the person has not answered is listed, and the page decides what to grey out.

import type { FormDescriptor } from "~/api";

export type RequiredField = "title" | "start" | "end" | "proxy";

export type Answers = {
  startsAt: string | null;
  endsAt: string | null;
  proxyUserId: number;
  displayName: string;
};

/**
 * missingFields lists the required fields that have no usable answer yet.
 *
 * A stand-in counts as answered only when they are one of the offered options
 * and the announcement can actually name them: the form already says next to
 * the field that somebody without a recording will not do, so letting the
 * save go through and fail later would contradict it.
 */
export function missingFields(d: FormDescriptor, v: Answers): RequiredField[] {
  const out: RequiredField[] = [];
  if (d.displayName?.required && !v.displayName.trim()) out.push("title");
  if (d.start?.required && !v.startsAt) out.push("start");
  if (d.end?.required && !d.end.allowOpenEnded && !v.endsAt) out.push("end");
  if (d.proxy?.required) {
    const chosen = d.proxy.options.find((o) => o.id === v.proxyUserId);
    if (!chosen || !chosen.canBeNamed) out.push("proxy");
  }
  return out;
}
